import React from "react"
import PropTypes from "prop-types"

import ImageSVGPatternMS02 from "@images/ms2-pattern-examples.svg"
import ImageSVGPatternMS03 from "@images/ms3-pattern-examples.svg"

// Helpers
import Image from "../image"
import BackgroundImage from "../../helpers/background-image"

import "./ExampleBlock.scss"

const ExampleBlock = ({ bodyCopy, brandName, country, colors, exampleImage, introCopy, order, title }) => {
  const svgBackground = { backgroundImage: `url(${ImageSVGPatternMS03})` }
  const backgroundGradient = {
    background: `linear-gradient(to right bottom, #ffffff00 50%, ${colors.contentBackground} 50%)`,
  }

  return (
    <div className="columns is-gapless is-multiline example-block">
      <div className="column is-one-third is-hidden-mobile" style={{ position: "relative" }}>
        <div className="example-svg-pattern">
          <div className="svg-pattern" style={svgBackground}></div>
        </div>
        <BackgroundImage
          filename={`${exampleImage}-background.jpg`}
          className="example-background-image"
          loading="eager"
          alt={brandName}
        />
      </div>

      <div className="column is-one-third">
        <div className="title-container">
          <div className="is-hidden-desktop">
            <BackgroundImage
              filename={`${exampleImage}-background.jpg`}
              loading="eager"
              className="example-image-mobile is-hidden-desktop"
              alt={brandName}
            />
          </div>
          <div className="background-split" style={backgroundGradient}></div>
          <div className="example-title">
            <div className="example-image">
              <Image filename={`${exampleImage}.jpg`} />
            </div>
            <div className="example-title__content" style={{ backgroundColor: colors.cardBackground }}>
              <h2 className="example-title__order" style={{ color: colors.cardBackground }}>
                {order}.
              </h2>
              <p className="example-title__brand" style={{ color: colors.brandText }}>
                {brandName}
              </p>
              <p className="example-title__country" style={{ color: colors.brandText }}>
                {country}
              </p>
              <h4>{title}</h4>
            </div>
          </div>
        </div>
      </div>

      <div className="column is-one-third">
        <div className="example-content" style={{ backgroundColor: colors.contentBackground }}>
          <p className="example-intro-copy" dangerouslySetInnerHTML={{ __html: introCopy }} />
          <p className="example-body-copy" dangerouslySetInnerHTML={{ __html: bodyCopy }} />
        </div>
      </div>
    </div>
  )
}

ExampleBlock.defaultProps = {
  colors: {
    brandText: "#B5FEFE",
    cardBackground: "#7D53DE",
    contentBackground: "#CCB9F3",
  },
}

ExampleBlock.propTypes = {
  title: PropTypes.string,
  backgroundImageUrl: PropTypes.string,
  bodyCopy: PropTypes.string,
  order: PropTypes.string,
  colors: PropTypes.object,
}

export default ExampleBlock
